import React, { Component, Fragment } from "react";
import * as _ from "lodash";
import {Rule} from "../../models/mailroom-school-config-rules/Rule";
import {MailroomSchoolConfig} from "../../models/MailroomSchoolConfig";

export interface ConditionalConfigItemProps {
    path: string[];
    config: MailroomSchoolConfig;
    configRules: Rule[];
    children(rule: Rule) :any;
}

export interface ConditionalConfigItemState {
    rule: Rule;
    show: boolean;
}


export class ConditionalConfigItem extends Component<ConditionalConfigItemProps, ConditionalConfigItemState> {

    constructor(props: ConditionalConfigItemProps) {
        super(props);

        this.state = {
            rule: this.props.configRules.find(c => _.isEqual(c.path,this.props.path)) as Rule,
            show: false
        };
    }

    public async componentDidMount()
    {
        this.update();
    }

    public componentDidUpdate(prevProps: Readonly<ConditionalConfigItemProps>, prevState: Readonly<ConditionalConfigItemState>, snapshot?: any)
    {
        if(this.props.config !== prevProps.config)
        {
            this.update();
        }
    }
    
    private update()
    {
        let showDataServiceType = true;
        if(this.state.rule?.requirements.dataServiceTypes && this.props.config.misDataServiceType)
        {
            showDataServiceType =_.includes(this.state.rule.requirements.dataServiceTypes,this.props.config.misDataServiceType)
        }
        
        let showFeature = true;
        if(this.state.rule?.requirements.features)
        {
            const configFeatures = this.props.config.options as {[key:string]: boolean};
            showFeature = _.some(this.state.rule.requirements.features,featureName => configFeatures[featureName]);
        }
        
        this.setState({
            show: showDataServiceType && showFeature
        });
    }
    
    public render() {
        
        if(!this.state.show) {
            return null;
        }
        
        return (
            <Fragment>
                {this.props.children(this.state.rule)}
            </Fragment>
        );
    }
}
